RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const View = RivalIQ.channels.views.DismissableView.mixin({
        template: '#channelsChannelWallSizePaidReachTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        className: `panel panel-default ${RivalIQ.channels.views.ChannelWall.prototype.className}`,

        initialize: function () {
            const me = this;

            me.options = _.extend(me.options || {}, {
                state: RivalIQ.state.user
            });
        }
    });

    const Widget = widgets.PaidReachNotificationWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        wasBoosted: function () {
            const me = this;
            return me.curation.wasBoosted;
        },

        filter: function () {
            const me = this;

            // only want to show the panel (return false) when we don't have Facebook Ads Insights,
            // we have not dismissed the widget, and the post was boosted
            if (!RivalIQ.state.account.channelSupported(RivalIQ.enums.sourceMask.FACEBOOK_BOOSTED_POST_INSIGHTS)) {
                return me.isDismissed({
                    state: RivalIQ.state.user
                }) || !me.wasBoosted();
            }

            return true;
        },

        panelView: View

    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.PAID_REACH_NOTIFICATION, Widget);

});
